module.exports = require("./lib/_stream_transform.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/readable-stream/transform.js
 ** module id = 759
 ** module chunks = 2
 **/